<template>
	<div class="partial partial--clients clients">
		<div class="partial__heading">
			<h1 class="partial__title">Clients</h1>
			<div class="partial__actions">
				<router-link :to="{name: 'client' }" class="mdc-button mdc-button--primary mdc-button--outline">
					<div class="mdc-button__ripple"></div>
					<i class="material-icons mdc-button__icon" aria-hidden="true">add</i>
					<span class="mdc-button__label">Add Client</span>
				</router-link>
			</div>
		</div>
		<div class="partial__body">
			<card>
				<list-clients :clients="clients" :isLoading="isLoading" />
				<pagination :count="clients.length" :limit="limit" />
			</card>
		</div>
		<modal @close="hideModal" :open="modalVisible" :title="modalTitle">
			<router-view class="main__modal" slot="content" name="pageModal" />
		</modal>
	</div>
</template>

<script>
import Card from '@/components/Card'
import ListClients from '@/components/ListClients'
import Modal from '@/components/Modal'
import Pagination from '@/components/Pagination'

export default {
	name: 'PartialClients',
	components: {
		Card,
		ListClients,
		Modal,
		Pagination
	},
	data: () => ({
		orderBy: 'name',
	}),
	computed: {
		isLoading() {
			return this.$store.getters['misc/loading']
		},
		modalVisible() {
			return this.$route.name == 'client'
		},
		modalTitle() {
			return this.$route.meta.modalTitle
		},
		clients() {
			return this.$store.getters['client/clients'].map(c => {
				c.nameEmail = [c.contactName, c.contactEmail].filter(n => n).join(`<br />`)
				return c
			})
		},
		limit() {
			return this.$route.query.limit || 20
		},
	},
	methods: {
		hideModal(clicked) {
			if (clicked) {
				this.$router.back()
			}
		},
	},
	metaInfo() {
		return {
			title: this.modalTitle || `Clients`,
		}
	},
	watch: {
		$route: {
			immediate: true,
			handler: function(to, from) {
				if ((to && to.name == 'clients') && (from && from.name == 'client')) return
				const { orderBy, startAt, } = to.query
				this.$store.dispatch('client/list',  {orderBy, limit: this.limit, startAt, })
			},
		},
	},
}
</script>

<style scoped lang="scss">

</style>
